import {
  createFrontendPlugin,
  type FrontendPlugin,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { compatWrapper } from '@backstage/core-compat-api';

import { PROJECT_SLUG_ANNOTATION } from './hooks/use-compliance-facts';

// Replaces the Compliance card from @roadiehq/backstage-plugin-github-insights,
// which is disabled in app-config.yaml. That one renders two checks - license and
// protected branches - from a fixed 78-line component with no extension point.
// Two cards both claiming to report compliance, one with two checks and one with
// fourteen, is worse than either alone.
const complianceCard = EntityCardBlueprint.make({
  name: 'compliance',
  params: {
    // Same annotation the github-actions and github-insights plugins key off, so
    // the card appears exactly where a repository is already linked.
    filter: (entity: { metadata?: { annotations?: Record<string, string> } }) =>
      Boolean(entity.metadata?.annotations?.[PROJECT_SLUG_ANNOTATION]),
    loader: async () => {
      const { ComplianceCard } = await import('./components');
      return compatWrapper(<ComplianceCard />);
    },
  },
});

export const githubCompliancePlugin: FrontendPlugin = createFrontendPlugin({
  pluginId: 'github-compliance',
  extensions: [complianceCard],
});
